//import Elvis from 'elvis-driver/browser'
//import request from 'request'
import { AssetsApiClient } from '@woodwing/assets-client-sdk';


export default {
  serverUrl: '',

  resolvedLogin: null,

  _getFolderPath() {
    return (
      window.elvisContext && window.elvisContext.activeTab.folderSelection.length ?
        window.elvisContext.activeTab.folderSelection[0].assetPath :
        '/'
    )
  },


  search(query) {
    return (
      this.client
        .search({ q: query })
    )
  },

  update(id, metadata) {
    return (
      this.client
        .update(id, metadata)
    )
  },

  updateBulk(query, metadata) {
    const apiClient = window.apiClient
    //console.log({ query, metadata })

    return (
      apiClient
        .updatebulk(query, metadata)
    )
  },

  getHeadersWithDefaults(headers) {
    let newHeader = {
      'X-CSRF-TOKEN': this._token,
      'Content-Type': 'application/json',
      ...headers
    }

    return newHeader
  },

  sendRendtionData(data, url) {
    // const request = new Request(`${url}/api/get_renditions`, {
    //   method: 'POST',
    //   timeout: 1000,
    //   body: JSON.stringify(data),
    //   headers: new Headers(this.getHeadersWithDefaults('Content-Disposition: attachment; filename="filename.zip"; filename*="filename.zip"'))
    // })

    // return fetch(request);
  },

  getFieldInfo(data) {
    // const request = new Request(`/services/fieldinfo`, {
    //   method: 'GET',
    //   body: JSON.stringify(data),
    //   headers: new Headers(this.getHeadersWithDefaults())
    // })

    // return fetch(request);
  },

  getMessageInfo(data) {
    // const request = new Request(`/services/messages`, {
    //   method: 'GET',
    //   body: JSON.stringify(data),
    //   headers: new Headers(this.getHeadersWithDefaults())
    // })

    // return fetch(request);
  },

  version(assetId, version) {
    // const request = new Request(`/services/version/promote?assetId=${assetId}&version=${version}`, {
    //   method: 'POST',
    //   // body: JSON.stringify({ assetId, version }),
    //   headers: new Headers(this.getHeadersWithDefaults())
    // })
    // return fetch(request)
  },

  getConfig(url) {
    // return new Promise((resolve, reject) => {
    //   let r = request({
    //     timeout: 120000,
    //     url: `${url}`,
    //     encode: null,
    //     headers: new Headers(this.getHeadersWithDefaults())
    //   })
    //   r.on('response', res => {
    //     if (res.statusCode == 200) {
    //       let body = ''
    //       res.on('data', (data) => {
    //         body += data
    //       })
    //       res.on('end', () => {
    //         try {
    //           let json = JSON.parse(body)
    //           resolve(json)
    //         } catch (error) {
    //           reject()
    //         }
    //       })
    //       res.on('error', (error) => {
    //         reject(error)
    //       })
    //     } else {
    //       reject(res.statusCode)
    //     }
    //   })
    //   r.on('error', error => {
    //     reject(error)
    //   })
    // })
  }
}
